import moment from "moment";
import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { JobDetails } from "@/Components/common/client/createjob/steps/JobDetails";
import { SelectDates } from "@/Components/common/client/createjob/steps/SelectDates";
import { TimeSelection } from "@/Components/common/client/createjob/steps/TimeSelection";
import Verification from "@/Components/common/client/createjob/steps/Verification";
import BankedPushlishContractDurationModal from "@/Components/modals/client/bankPublishContract/BankedPushlishContractDurationModal";
import {
  fetchClientPublishBankContract,
  updateactivePages,
} from "@/reducers/clientcommon";
import {
  updateJobData,
  updateJobShiftList,
  deSelectShortListAllCandidate,
  fetchJobTemplates,
  fetchRoles,
  updateActiveTemplateType,
  updateTemplateLoading,
} from "@/reducers/clientcreatejob";

import BookedInvitedBankCandidateForContractModal from "../../Components/modals/client/bankPublishContract/BookedInvitedBankCandidateForContractModal";
import { setSession } from "../../reducers/session";
import useTitle from "../../utilities/hooks/useTitle";

/**
 * Create a job using the provided session data, templates, client settings, and candidate role.
 *
 * @param {Array} allTemplates - the list of all available templates
 * @param {Object} clientSetting - the client settings for the job
 * @param {String} candidateRole - the role of the candidate for the job
 * @return {void}
 */
const CreateJob = ({
  allTemplates = [],
  clientSetting = {},
  candidateRole = [],
}) => {
  const navigate = useNavigate();
  useTitle("Post a job");
  const { session } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const { activeStep, jobData, jobShiftObj } = useSelector(
    (state) => state.clientCreateJob,
  );

  useLayoutEffect(() => {
    if (session.client_allow_publish_job == 0) {
      const callback = () => {
        navigate("/dashboard");
      };
      dispatch(
        setSession({
          flashMessage:
            "You are not allowed to publish job. Please contact support.",
          callback,
        }),
      );
    }
  }, []);
  useEffect(() => {
    dispatch(updateActiveTemplateType("generic"));
    dispatch(
      updateactivePages({
        activePage: "postJob",
        activeSubPage: null,
      }),
    );
    //fetch roles
    dispatch(fetchRoles());
    // template loading and api
    dispatch(updateTemplateLoading(true));
    dispatch(fetchJobTemplates());
    dispatch(fetchClientPublishBankContract());
    dispatch(deSelectShortListAllCandidate());

    setTimeout(() => {
      dispatch(
        updateJobData({
          admin_per: session.admin_per,
          visit_per: session.visit_per,
        }),
      );
    }, 200);
  }, []);
  /**
   * Updates the days array and job shift objects based on the jobData start date, end date, and other details.
   */
  const updateDays = (callback, sDates = []) => {
    let selectedDates = sDates.length ? sDates : jobData.selectDateJobDates;
    let days = [];
    let jobShiftObj = [];
    selectedDates.forEach((date) => {
      let day = moment(date, "DD-MM-YYYY").format("dddd");
      if (!days.includes(day)) {
        days.push(day);
      }
      let obj = {
        date: date,
        day: day,
        startTime: jobData.startTime,
        endTime: jobData.endTime,
        break: jobData.breakTime,
        admin: jobData.adminTime,
        adminCharge: 0,
        rateName: "",
        rate: 0,
        total: 0,
        countDays: null,
        rate_values: [],
        clientPay: null,
      };
      jobShiftObj.push(obj);
    });
    dispatch(
      updateJobData({
        weekDays: days,
      }),
    );
    dispatch(updateJobShiftList(jobShiftObj));
    callback && callback(jobData.selectDateJobDates);
  };
  /**
   * Updating DateRanges in datepicker based on the job shift table dates
   *
   * @return {JSX.Element} The component to be rendered based on the value of activeStep.
   */
  useEffect(() => {
    if (jobShiftObj.length) {
      let isStartTimeSame = jobShiftObj.every((item) => {
        return item.startTime === jobShiftObj[0].startTime;
      });
      let isEndTimeSame = jobShiftObj.every((item) => {
        return item.endTime === jobShiftObj[0].endTime;
      });
      if (
        isStartTimeSame &&
        isEndTimeSame &&
        jobShiftObj[0].startTime &&
        jobShiftObj[0].endTime
      ) {
        dispatch(
          updateJobData({
            startTime: jobShiftObj[0].startTime,
            endTime: jobShiftObj[0].endTime,
          }),
        );
      }
      let curDates = jobShiftObj.map((shift) => shift.date);
      let newJobRanges = jobData.selectDatesRanges.filter((range) => {
        return curDates.includes(range[0]);
      });
      setTimeout(() => {
        dispatch(
          updateJobData({
            // startDate: curDates[0],
            // endDate: curDates[curDates.length - 1],
            selectDatesRanges: newJobRanges,
            selectDateJobDates: curDates,
          }),
        );
      }, 100);
    }
  }, [jobShiftObj]);
  return (
    <>
      {activeStep === 1 ? <JobDetails /> : null}
      {activeStep === 2 ? <SelectDates updateDays={updateDays} /> : null}
      {activeStep === 3 ? <TimeSelection updateDays={updateDays} /> : null}
      {activeStep === 4 ? <Verification /> : null}
      <BankedPushlishContractDurationModal />
      <BookedInvitedBankCandidateForContractModal />
    </>
  );
};

export default CreateJob;
